import React, { PropsWithChildren } from 'react';
import { AnimalTypesProvider } from './AnimalTypesContext';
import { DoseParamsProvider } from './DoseParamsContext';
import { GAListProvider } from './GeographicalAreasContext';
import { IntegrationProvider } from './IntegrationContext';
import { SymptomsProvider } from './SymptomsContext';
import { UiStateProvider } from './uiState.context';
import { BreedsProvider } from './BreedsContext';
import { LLMDiagnoseProvider } from './LLMDiagnoseContext';
import { SoapNotesProvider } from './SoapNotesContext';

export const AppParamsProvider = ({ children }: PropsWithChildren<{}>) => {
  return (
    <UiStateProvider>
      <AnimalTypesProvider>
        <SymptomsProvider>
          <GAListProvider>
            <DoseParamsProvider>
              <LLMDiagnoseProvider>
                <IntegrationProvider>
                  <BreedsProvider>
                    <SoapNotesProvider>{children}</SoapNotesProvider>
                  </BreedsProvider>
                </IntegrationProvider>
              </LLMDiagnoseProvider>
            </DoseParamsProvider>
          </GAListProvider>
        </SymptomsProvider>
      </AnimalTypesProvider>
    </UiStateProvider>
  );
};
